import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { DomainDataService } from '../../../../services';
import { AccSessionViewerDialogDataService } from './acc-session-viewer-dialog-data.service';
import { AccSessionDetailsPart } from './details/details.part';
import { AccSessionSignUpsPart } from './sign-ups/sign-ups.part';
@Component({
	selector: 'programs-acc-session-viewer-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		AccSessionSignUpsPart,
		AccSessionDetailsPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-session-viewer.dialog.html',
})

export class AccSessionViewerDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<AccSessionViewerDialog>);
	public dialogContext: DialogContext<{ accSessionId: number, topicId: number }> = inject(MAT_DIALOG_DATA);

	private readonly domainData = inject(DomainDataService);
	private readonly dialogDataservice = inject(AccSessionViewerDialogDataService);
	private readonly util = inject(UtilityService);

	public readonly headerTitle = computed(() => {
		const details = this.dialogDataservice.accSessionDetails()!;
		if (details) {
			const topicName = this.domainData.data().topicsMap[details.topicId]?.name;
			const startUTC = details.startUTC;
			const formattedDate = this.util.date.formatUTC(startUTC, 'MM/DD/YYYY', 'No Time', 'en-US')
			return `${topicName}: ${formattedDate}`;
		}
		return '';
	});

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data)
			await this.dialogDataservice.getAccSessionData(data.accSessionId, data.topicId);
	}

	public actions: DialogAction[] = [{
		id: 'close',
		cssClass: signal('btn-standard'),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: "no-action",
		willCloseDialog: true,
	}];

}